import api from "@/util/api"

const MAX_API_ATTEMPTS = 3;

export const state = {

}

export const mutations = {

}

export const actions = {

}

export const getters = {

}